import React, { useRef, useState, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useGesture } from "@use-gesture/react";
import { useSpring, animated } from "@react-spring/web";
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;
const PDFViewer = ({ pdfBlobUrl, resetTrigger }) => {
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1);
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [{ x, y }, api] = useSpring(() => ({ x: 0, y: 0 }));
  const clamp = (value, min, max) => Math.max(min, Math.min(value, max));
  const getBounds = () => {
    const container = containerRef.current;
    const content = contentRef.current;
    if (!container || !content) return { minX: 0, maxX: 0, minY: 0, maxY: 0 };
    const containerRect = container.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();
    const minX = Math.min(0, containerRect.width - contentRect.width);
    const minY = Math.min(0, containerRect.height - contentRect.height);
    return { minX, maxX: 0, minY, maxY: 0 };
  };
  useEffect(() => {
    resetView();
  }, [pdfBlobUrl]);

  useEffect(() => {
    resetView();
  }, [resetTrigger]);
  useGesture(
    {
      onPinch: ({ offset: [d], event }) => {
        event.preventDefault();
        const newScale = Math.min(4, Math.max(0.5, d));
        setScale(newScale);
        api.start({ x: 0, y: 0 });
      },
      onDrag: ({ offset: [dx, dy] }) => {
        const { minX, maxX, minY, maxY } = getBounds();
        api.start({
          x: clamp(dx, minX, maxX),
          y: clamp(dy, minY, maxY),
        });
      },
    },
    {
      target: containerRef,
      pinch: { scaleBounds: { min: 0.5, max: 4 }, rubberband: false },
      drag: { from: () => [x.get(), y.get()] },
      eventOptions: { passive: false },
    }
  );
  // Reset zoom and position
  const resetView = () => {
    setScale(1);
    api.start({ x: 0, y: 0 });
    setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.scrollTo({ top: 0, behavior: "auto" });
      }
    }, 0);
  };
  return (
    <div>
      <div
        ref={containerRef}
        style={{
          width: "100%",
          height: "74vh",
          overflow: "scroll",
          overflowY: "auto",
          touchAction: "none",
          position: "relative",
          background: "#eef2f6",
          padding: "24px 0",
          borderRadius: "16px",
        }}
      >
        <animated.div
          ref={contentRef}
          style={{
            x,
            y,
            width: `${scale * 750}px`,
            minHeight: `${scale * (numPages || 1) * 600}px`,
            position: "relative",
            margin: "0 auto",
          }}
        >
          <Document
            file={pdfBlobUrl}
            onLoadSuccess={({ numPages }) => setNumPages(numPages)}
            renderMode="canvas"
          >
            {Array.from(new Array(numPages), (_, index) => (
              <div
                key={`page_wrapper_${index + 1}`}
                style={{
                  background: "#ffffff",
                  boxShadow: "0 12px 30px rgba(15, 23, 42, 0.12)",
                  borderRadius: "12px",
                  padding: "8px",
                  marginBottom: "20px",
                }}
              >
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  scale={scale}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </div>
            ))}
          </Document>
        </animated.div>
      </div>
    </div>
  );
};
export default PDFViewer;
